import {
  menu_item_checkbox_style_default
} from "./chunk.7OL4GPLO.js";
import {
  FadvMenuItemBase
} from "./chunk.QHZ3R2SE.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  n
} from "./chunk.D5EJUUKV.js";
import {
  $,
  w
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/menu-item/menu-item-checkbox.ts
var FadvMenuItemCheckbox = class extends FadvMenuItemBase {
  handleClick(_event) {
    this.checked = !this.checked;
  }
  getRole() {
    return "menuitemcheckbox";
  }
  renderChecked() {
    if (!this.checked)
      return w;
    return $`<span part="checked-icon" class="checkbox__icon"><svg width="16px" height="16px" viewBox="0 0 16 16"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round"><g stroke="currentColor" stroke-width="2"><g transform="translate(3.428571, 3.428571)"><path d="M0,5.71428571 L3.42857143,9.14285714"></path><path d="M9.14285714,0 L3.42857143,9.14285714"></path></g></g></g></svg></span>`;
  }
  render() {
    return $`<div part="base" class=${o({
      "menu-item": true,
      "menu-item--checked": this.checked,
      "menu-item--disabled": this.disabled,
      "menu-item--has-prefix": this.hasSlot.test("prefix"),
      "menu-item--has-suffix": this.hasSlot.test("suffix")
    })} @click=${this.handleClick} ><span class="menu-item__check">${this.renderChecked()}</span><span part="prefix" class="menu-item__prefix"><slot name="prefix"></slot></span><span part="label" class="menu-item__label"><slot></slot></span><span part="suffix" class="menu-item__suffix"><slot name="suffix"></slot></span></div>`;
  }
};
FadvMenuItemCheckbox.styles = menu_item_checkbox_style_default;
FadvMenuItemCheckbox = __decorateClass([
  n("fadv-menu-item-checkbox")
], FadvMenuItemCheckbox);

export {
  FadvMenuItemCheckbox
};
